export default "__VITE_ASSET__B93YMb6B__"